import { useContext } from 'react';
import LanguageContext from 'contexts/UI/language/LanguageContext';

export default function useContextUILanguages() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useContextUILanguages must be used within a LanguageProvider');
  }
  return context;
}
